/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the SyncUserResponse interface.
 */
export function instanceOfSyncUserResponse(value) {
    if (!('message' in value) || value['message'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
export function SyncUserResponseFromJSON(json) {
    return SyncUserResponseFromJSONTyped(json, false);
}
export function SyncUserResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'message': json['message'],
        'status': json['status'],
    };
}
export function SyncUserResponseToJSON(json) {
    return SyncUserResponseToJSONTyped(json, false);
}
export function SyncUserResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'message': value['message'],
        'status': value['status'],
    };
}
